import { api, API_ENDPOINTS } from '../lib/api';
import type { LocationStatusResponse, ChargePointStatusResponse, LiveTransactionStatus } from '../types/live';

export const liveService = {
  getLocationStatuses: async (ids?: string[]): Promise<LocationStatusResponse> => {
    const params = ids?.length ? { ids: ids.join(',') } : {};
    const response = await api.get<LocationStatusResponse>(API_ENDPOINTS.LIVE.LOCATIONS, { params });
    return response.data;
  },

  getChargePointStatus: async (id: string): Promise<ChargePointStatusResponse> => {
    const response = await api.get<ChargePointStatusResponse>(API_ENDPOINTS.LIVE.CHARGE_POINT(id));
    return response.data;
  },

  getTransactionStatus: async (id: string): Promise<LiveTransactionStatus> => {
    const response = await api.get<LiveTransactionStatus>(API_ENDPOINTS.LIVE.TRANSACTION(id));
    return response.data;
  },
};
